/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterESmall = createReactComponent("letter-e-small", "IconLetterESmall", [
  ["path", { d: "M14 8h-4v8h4", key: "svg-0" }],
  ["path", { d: "M10 12h2.5", key: "svg-1" }]
]);

export { IconLetterESmall as default };
//# sourceMappingURL=IconLetterESmall.js.map
